var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "p-stroke",
    d: "M3.95455 0.998047H28.1364C29.7681 0.998047 31.0909 2.32084 31.0909 3.95259V17.7708C31.0909 19.4025 29.7681 20.7253 28.1364 20.7253H3.95455C2.3228 20.7253 1 19.4025 1 17.7708V3.95259C1 2.32084 2.32279 0.998047 3.95455 0.998047Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "p-stroke",
    d: "M33.5 12.9345V9.47998",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "p-fill",
    d: "M2.61328 3.5208C2.61328 2.99613 3.03861 2.5708 3.56328 2.5708H6.75874V19.1526H3.56328C3.03861 19.1526 2.61328 18.7273 2.61328 18.2026V3.5208Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowBattery);
export default __webpack_public_path__ + "static/media/LowBattery.9bf27298dd83648213493adbd067b543.svg";
export { ForwardRef as ReactComponent };